<template>
<div>
    <v-list-item  v-ripple="phoneOnly" :class="{'px-6': phoneOnly, 'px-0': pcOnly}">
        <v-list-item-icon>
            <v-avatar size="60" color="grey lighten-3" style="border-radius: 6px">
                <v-icon size="35" color="primary">mdi-robot-outline</v-icon>
            </v-avatar>
        </v-list-item-icon>
        <v-list-item-content>
            <v-list-item-title>
                <span class="muted--text">سؤال</span>
                <!-- <v-chip v-if="!question.answer" small class="ms-2 px-2" color="grey" dark>في انتظار الإجابة</v-chip> -->
                <v-chip v-if="$route.name === 'my-questions'" small class="ms-2 px-2" color="primary" dark><strong>ذكاء اصطناعي</strong></v-chip>
            </v-list-item-title>
            <v-list-item-subtitle class="strong-text--text">
                <template v-if="question.question">{{question.question}}</template>
                <div v-else-if="question.image"><v-icon small class="me-1" color="grey">mdi-image</v-icon>صورة</div>
            </v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-icon class="ms-1">
            <v-btn v-if="question.answer" rounded color="primary" depressed dense @click="chatDialog = true;">
                <v-icon class="me-1" size="20" left>mdi-file-check-outline</v-icon>
                <span>{{pcOnly ? 'عرض الإجابة' : 'الإجابة'}}</span>
            </v-btn>
        </v-list-item-icon>
    </v-list-item>
    <v-dialog v-if="question.answer" v-model="chatDialog" max-width="750" overlay-color="#000" :fullscreen="phoneOnly" :hide-overlay="phoneOnly" :transition="phoneOnly ? 'dialog-bottom-transition' : 'dialog-transition'">
        <v-card class="d-flex flex-column" style="height: 100%; max-height: 600px;">
            <v-card-title class="d-flex align-center justify-space-between">
                <span>محادثة عبد الجواد AI</span>
                <v-btn icon @click="chatDialog = false">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text class="flex-grow-1 pa-0" style="overflow-y: auto;" ref="chatContainer">
                <div class="chat-messages pa-4">
                    <div v-if="chatMessages.length === 0" class="text-center py-8">
                        <v-icon size="48" color="primary" class="mb-4">mdi-robot-outline</v-icon>
                        <div style="font-size: 1.1rem;" class="grey--text">لا توجد رسائل</div>
                    </div>
                    <div 
                        v-for="(message, index) in chatMessages" 
                        :key="'message-' + index" 
                        :class="['chat-message', message.sender === 'user' ? 'user-message' : 'ai-message']"
                    >
                        <div class="chat-bubble">
                            <div v-if="message.image" class="chat-image-container mb-2">
                                <img :src="getImageSrc(message.image)" alt="question image" class="chat-image" />
                            </div>
                            <div v-if="message.sender === 'user'" class="chat-text">
                                {{ message.text || 'جاوب على الصورة' }}
                            </div>
                            <div v-else class="chat-text ai-response" v-html="formatMessage(message.text)"></div>
                        </div>
                    </div>
                    <div ref="messagesEnd"></div>
                </div>
            </v-card-text>
        </v-card>
    </v-dialog>
</div>
</template>

<script>

import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'
import formatAiMessage from '@/helpers/format-ai-message'

export default {
    props: {
        question: {},
        allAiQuestions: {
            type: Array,
            default: () => []
        }
    },
    data(){
        return {
            chatDialog: false,
            chatMessages: [],
            conversationQuestions: [],
        }
    },
    computed: {
        ...GlobalComputed,
        
    },
    watch: {
        chatDialog(val) {
            if (val) {
                this.loadConversation();
                this.$nextTick(() => {
                    // this.scrollToBottom();
                });
            } else {
                this.chatMessages = [];
                this.conversationQuestions = [];
            }
        },
        chatMessages() {
            this.$nextTick(() => {
                // this.scrollToBottom();
            });
        }
    },
    methods: {
        ...GlobalMethods,
        formatMessage(text) {
            return formatAiMessage(text);
        },
        getImageSrc(image) {
            if (!image) return null;
            if (typeof image === 'string') {
                // If it's a URL or data URL
                if (image.startsWith('data:') || image.startsWith('http')) {
                    return image;
                }
            }
            return image;
        },
        async loadConversation() {
            // If this question has child_questions (meaning it's a parent), use them
            // Otherwise, if it has a parent_question_id, we need to find the parent
            if (this.question.child_questions && this.question.child_questions.length > 0) {
                // This is a parent question with children
                this.conversationQuestions = [this.question, ...this.question.child_questions];
                this.buildChatMessages();
                return;
            }
            
            // If this question has a parent_question_id, find the parent in allAiQuestions
            if (this.question.parent_question_id && this.allAiQuestions && this.allAiQuestions.length > 0) {
                const parent = this.allAiQuestions.find(q => q.id === this.question.parent_question_id);
                if (parent && parent.child_questions) {
                    // Found parent with children, include parent and all children
                    this.conversationQuestions = [parent, ...parent.child_questions];
                    this.buildChatMessages();
                    return;
                }
            }
            
            // Fallback: just use this single question
            this.conversationQuestions = [this.question];
            this.buildChatMessages();
        },
        buildChatMessages() {
            this.chatMessages = [];
            
            // Sort questions by created_at_timestamp
            const sortedQuestions = [...this.conversationQuestions].sort((a, b) => {
                const timestampA = a.created_at_timestamp || 0;
                const timestampB = b.created_at_timestamp || 0;
                return timestampA - timestampB; // Ascending order for conversation flow
            });
            
            sortedQuestions.forEach(q => {
                // Add user question
                this.chatMessages.push({
                    sender: 'user',
                    text: q.question || null,
                    image: q.image || null
                });
                
                // Add AI answer if available
                if (q.answer) {
                    this.chatMessages.push({
                        sender: 'ai',
                        text: q.answer
                    });
                }
            });
        },
        scrollToBottom() {
            this.$nextTick(() => {
                const container = this.$refs.chatContainer;
                const messagesEnd = this.$refs.messagesEnd;
                if (container && messagesEnd) {
                    messagesEnd.scrollIntoView({ behavior: 'smooth', block: 'end' });
                }
            });
        }
    }
}
</script>

<style lang="scss" scoped>
.chat-messages {
    min-height: 300px;
    max-height: 500px;
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.chat-message {
    display: flex;
    margin-bottom: 8px;

    &.user-message {
        justify-content: flex-start;

        .chat-bubble {
            background-color: #332575 !important;
            color: white !important;
            border-radius: 18px 18px 4px 18px;
            max-width: 75%;
        }
    }

    &.ai-message {
        justify-content: flex-end;

        .chat-bubble {
            background-color: rgba(0, 0, 0, 0.05);
            color: rgba(0, 0, 0, 0.87);
            border-radius: 18px 18px 18px 4px;
            max-width: 75%;
        }
    }

    .chat-bubble {
        padding: 12px 16px;
        word-wrap: break-word;
        line-height: 1.5;
    }

    .chat-text:not(.ai-response) {
        white-space: pre-wrap;
    }

    .chat-image-container {
        margin-bottom: 8px;
        
        .chat-image {
            max-width: 100%;
            max-height: 300px;
            border-radius: 8px;
            object-fit: contain;
        }
    }
}
</style>

<style lang="scss">
// Global styles for AI message formatting
.ai-response {
    .ai-heading {
        font-weight: 600;
        margin: 12px 0 8px 0;

        &.ai-h1 {
            font-size: 1.5em;
        }

        &.ai-h2 {
            font-size: 1.3em;
        }

        &.ai-h3 {
            font-size: 1.1em;
        }
    }

    .ai-bold {
        font-weight: 600;
    }

    .ai-italic {
        font-style: italic;
    }

    .ai-highlight {
        background-color: rgba(255, 235, 59, 0.3);
        padding: 2px 4px;
        border-radius: 3px;
    }

    .ai-code {
        background-color: rgba(0, 0, 0, 0.05);
        padding: 8px 12px;
        border-radius: 4px;
        font-family: 'Courier New', monospace;
        font-size: 0.9em;
        overflow-x: auto;
        margin: 8px 0;
    }

    .ai-tip {
        border-left: 3px solid var(--v-primary-base);
        padding-left: 12px;
        margin: 8px 0;
        font-style: italic;
        color: rgba(0, 0, 0, 0.7);
    }

    .ai-paragraph {
        margin: 2px 0;
        line-height: 1.6;

        &.ai-reference {
            color: rgba(0, 0, 0, 0.6);
            font-size: 0.9em;
            margin-top: 12px;
        }

        &.ai-book {
            color: rgba(0, 0, 0, 0.7);
            font-size: 0.95em;
        }

        &.ai-funny {
            color: rgba(0, 0, 0, 0.8);
            font-style: italic;
        }

        &.ai-scientific {
            color: rgba(0, 0, 0, 0.9);
            font-weight: 500;
        }

        &.ai-tip-paragraph {
            background-color: rgba(255, 235, 59, 0.1);
            padding: 8px 12px;
            border-radius: 4px;
            margin: 8px 0;
        }
    }

    .ai-arrow {
        font-weight: 600;
        color: var(--v-primary-base);
    }
    img{
        max-width: 100%;
        height: auto;
    }
}
</style>
